import { render, staticRenderFns } from "./CompanyInfoForm.vue?vue&type=template&id=771828cf&scoped=true"
import script from "./CompanyInfoForm.vue?vue&type=script&lang=js"
export * from "./CompanyInfoForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoForm.vue?vue&type=style&index=0&id=771828cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771828cf",
  null
  
)

export default component.exports